export const dashboardTexts = {
  helmetTitle: 'SEOSpace | Dashboard'
};

export const titleRowTexts = {
  welcome: 'Welcome, ',
  moreActions: 'More actions'
};

export const cardsTexts = {
  siteScore: 'Site Score',
  seoHealthScore: 'SEO Health Score',
  siteScoreTooltip:
    'The Site Health score is based on the number of errors and warnings found on your site. The higher the score, the fewer problems your site has, the better it is optimized for search engines, and the more user-friendly it is.',
  organicSearchTraffic: 'Organic Search Traffic',
  topPagesByTraffic: 'Top Pages by Traffic',
  topPageTooltip:
    'These are the top pages on this website in the past 30 days ranked by website traffic from Google.',
  page: 'Page',
  traffic: 'Traffic',
  siteScoreDesc: {
    first: 'The top 10% of Squarespace sites have an SEO score of above ',
    second: '95/100'
  },
  organicTrafficTooltip:
    'The number of visitors this website received from Google search in the past 30 days.',
  organicTraficImprove:
    'Great work, this website’s traffic from Google has increased in the past 30 days.',
  noGscOrganicTraffic:
    'To see your Search Traffic you need to connect Google Search Console.',
  organicTraficDecrease:
    'This site’s traffic from Google has decreased in the past 30 days - use SEOSpace to reverse this trend.',
  goodScoreDesc:
    'Your SEO score is great - continue adding blog posts and analyzing the competition to stay ahead.',
  gscNotConnected: 'Connect SEOSpace to Google Search Console',
  gscDesc:
    'Connect SEOSpace to Google Search Console to access personalized recommendations and advanced insight to improve your SEO.',
  gscBtnText: 'Connect to Google Search Console',
  gscGraphText:
    'Connect SEOSpace to Google Search Console to access these insights.',
  noChanges: 'No Changes',
  highScore:
    'You’re closing in on the top 10% — where SEO scores go above 95/100.',
  aIVisibilityScore: 'AI Visibility Score',
  aIVisibilityScoreTooltip:
    'This score shows how your brand appears in AI search engines. We use our own AI to check how often your brand is mentioned, how it is described, and how strongly it connects to your topics. The number gives you a quick way to see how visible you are.',
  connectNow: 'Connect Now',
  notMentioned: 'Not Mentioned',
  noAiDesc:
    'Right now, AI tools are unaware of your brand and do not mention it.',
  basicView: 'Basic View',
  detailedView: 'Detailed View',
  brand: 'Brand',
  visibilityScore: 'Visibility Score',
  noDataFound: 'No Data Found',
  basicViewTooltip: 'See key stats at a glance.',
  gotIt: 'Got it',
  detailViewTooltip: 'Get the full breakdown with more insights.',
  tryIt: 'Try It',
  trackYourKeywords: 'Track Your Keywords',
  new: 'New'
};

export const topOpportunitiesTexts = {
  topOpportunities: 'You might want to try…',
  seoBtn: 'Use SEOSpace’s Plugin',
  seoText: 'View how to improve this site’s SEO from our plugin.',
  seoTaskText: 'View a list of high-priority SEO tasks you need to fix.',
  taskBtn: 'View High-Priority Tasks',
  competitorText: 'Spy on your competitors to see what keywords they rank for.',
  competitorBtn: 'Spy on Competitors',
  blogPostText: 'Generate blog post ideas based on your competitors.',
  blogBtn: 'Blog Post Ideas'
};

export const chartComponentsTexts = {
  gscTitle: 'Connect SEOSpace to Google Search Console',
  gscDesc:
    'Connect SEOSpace to Google Search Console to access blog post ideas tailored to your niche and effortlessly generate briefs to fuel your content strategy.',
  watchTutorial: 'Watch Tutorial (03:30)',
  gscBtnText: 'Connect to Google Search Console'
};

export const DataGraphsTexts = {
  totalClicks: 'Total Clicks',
  totalClicksTooltip:
    ' is how many times a user clicked through to this site on Google search results.',
  totalImpressions: 'Total Impressions',
  totalImpressionTooltip:
    ' is how many times a user saw this website show up on Google search results - for example, if a site has 100 impressions, it was seen 100 times - this doesn’t mean it was clicked. Your goal is to rank higher on Google to turn impressions into clicks.',
  averageCTR: 'Average CTR',
  averageCTRTooltip:
    ' is the percentage of impressions that resulted in a click on Google search results.',
  averagePosition: 'Average Position',
  averagePositiontooltip:
    ' is the average position in Google search results for all the pages on this site.',
  clicks: 'Clicks',
  impressions: 'Impressions',
  position: 'Position',
  noGraphDataFound: 'No data found',
  addSiteDesc: `Add a site to analyze its content and SEO performance. This will help you gain valuable insights to improve your site's relevance, visibility, and user engagement.`,
  avgAiVisibility: 'Avg AI Visibility',
  avgAiVisibilityTooltip:
    ' shows how often your brand name appears in AI search results for your tracked topic. A higher score means better visibility.'
};

export const recommendedNextStepsTexts = {
  mainTitle: 'Recommended Next Steps'
};

export const celebrationModalTexts = {
  title: '🎉 Congrats! Your SEO Health Score Is Over 90/100!',
  descTitle: 'A strong SEO score is just the start.',
  descOne:
    'Your dashboard has been updated to guide you through what matters most next.',
  descTwo: 'Watch the tutorial to see what to focus on now. 👇',
  desc: `Getting your setup right puts you ahead, but outranking the competition depends on quality content, backlinks, and smart keyword selection.`,
  btn: 'Watch Tutorial',
  tutorialLink: 'https://www.youtube.com/watch?v=kiXiPnhn5c8'
};

export const KeywordTrackingDataTexts = {
  trackedKeywords: 'Tracked Keywords',
  addKeywordsDesc: 'Track keywords to monitor your SEO progress.',
  addKeywords: 'Add Keywords',
  trackedKeywordsTooltip:
    'The number of keywords being tracked on this website, and their respective positions on Google.',
  progressDesc: 'SEOSpace is currently tracking your keywords.'
};

export const isCelebrateSteps = (isAiVisibility: boolean, isGsc: boolean) => {
  const steps = [
    !isAiVisibility && {
      id: 'ai-visibility',
      imgName: 'ai-visibility/ai.svg',
      title: 'Try AI Visibility',
      desc: 'Boost your visibility in AI search engines like ChatGPT and Google AI.'
    },

    !isGsc && {
      id: 'connect-gsc',
      imgName: 'siteaudit/google.svg',
      title: 'Connect Google Search Console',
      desc: 'Access personalized recommendations and advanced SEO insight.'
    },
    {
      id: 'blog-ideas',
      imgName: 'keyword/rocket.svg',
      title: 'Add Blog Posts',
      desc: 'Get blog ideas from competitors to target keywords that drive traffic.'
    },
    {
      id: 'backlink',
      imgName: 'keyword/dataset.svg',
      title: 'View Backlinks',
      desc: 'See who links to your site and how it impacts your rankings.'
    },
    isAiVisibility &&
      isGsc && {
        id: 'ai-visibility',
        imgName: 'ai-visibility/ai.svg',
        title: 'AI Visibility',
        desc: 'See how AI views your brand and how you are mentioned.'
      },
    {
      id: 'track',
      imgName: 'keyword/track-rankings-v2.svg',
      title: 'Track Rankings',
      desc: 'Monitor where you rank for your keywords with clear, simple reports.'
    },
    {
      id: 'competitors',
      //imgName: 'keyword/chart.svg',
      imgName: 'siteaudit/search.svg',
      title: 'Spy on Competitors',
      desc: 'See what your competitors rank for and find new keyword opportunities.'
    },
    {
      id: 'localseo',
      imgName: 'siteaudit/local-seo.svg',
      title: 'Local SEO',
      desc: 'Improve how people nearby find your business with simple location updates and checks.'
    },
    {
      id: 'content-ideas',
      imgName: 'ai-visibility/boostAiVisibilitySteps/expand.svg',
      title: 'Content Ideas',
      desc: 'Get fresh blog post suggestions based on your site and topics you care about.'
    }
  ];
  return steps?.filter(Boolean);
};

export const getSteps = (
  isAgency: boolean,
  isAiVisibility: boolean,
  isGsc: boolean
) => {
  const steps = [
    !isAiVisibility && {
      id: 'ai-visibility',
      imgName: 'ai-visibility/ai.svg',
      title: 'Try AI Visibility',
      desc: 'Boost your visibility in AI search engines like ChatGPT and Google AI.'
    },

    !isGsc && {
      id: 'connect-gsc',
      imgName: 'siteaudit/google.svg',
      title: 'Connect Google Search Console',
      desc: 'Access personalized recommendations and advanced SEO insight.'
    },

    {
      id: 'plugin',
      imgName: 'siteaudit/plug.svg',
      title: 'Use SEOSpace’s Plugin',
      desc: 'View how to improve site’s SEO from our plugin.'
    },
    {
      id: 'seo-tasks',
      imgName: 'siteaudit/puzzle-piece.svg',
      title:
        !isAiVisibility && !isGsc
          ? 'View SEO Tasks'
          : isAiVisibility && !isGsc
          ? 'View High-Priority Tasks'
          : 'View SEO & AIO Tasks',
      desc:
        isAiVisibility && !isGsc
          ? 'View high-priority SEO tasks you need to fix.'
          : 'View high-priority personal tasks you need to fix.'
    },
    {
      id: 'competitors',
      imgName: 'siteaudit/search.svg',
      title: 'Spy on Competitors',
      desc: 'See what your competitors rank for and find new keyword opportunities.'
    },
    isAiVisibility &&
      isGsc && {
        id: 'ai-visibility',
        imgName: 'ai-visibility/ai.svg',
        title: 'AI Visibility',
        desc: 'See how AI views your brand and how you are mentioned.'
      },
    {
      id: isAgency ? 'track' : 'blog-ideas',
      imgName: isAgency
        ? 'keyword/track-rankings-v2.svg'
        : 'keyword/rocket.svg',
      title: isAgency ? 'Track Rankings' : 'Blog Post Ideas',
      desc: isAgency
        ? 'Monitor where you rank for your keywords with clear, simple reports.'
        : 'Generate ideas based on your competitors.'
    },
    {
      id: 'localseo',
      imgName: 'siteaudit/local-seo.svg',
      title: 'Local SEO',
      desc: 'Improve how people nearby find your business with simple location updates and checks.'
    },
    {
      id: 'content-ideas',
      imgName: 'ai-visibility/boostAiVisibilitySteps/expand.svg',
      title: 'Content Ideas',
      desc: 'Get fresh blog post suggestions based on your site and topics you care about.'
    }
  ];

  return steps?.filter(Boolean);
};

export const extraSteps = (
  isAgency: boolean,
  isAiVisibility: boolean,
  isGsc: boolean
) => {
  const steps = [
    //  Conditionally include AI Visibility
    !isAiVisibility && {
      imgName: 'ai-visibility/ai.svg',
      title: 'Try AI Visibility',
      desc: 'Boost your visibility in AI search engines like ChatGPT and Google AI.'
    },

    //  Conditionally include Google Search Console
    !isGsc && {
      imgName: 'siteaudit/google.svg',
      title: 'Connect Google Search Console',
      desc: 'Access personalized recommendations and advanced SEO insight.'
    },

    {
      imgName: 'siteaudit/vector.svg',
      title: 'Use SEOSpace’s Plugin',
      desc: 'View how to improve site’s SEO from our plugin.'
    },
    {
      imgName: 'siteaudit/union.svg',
      title: 'View High-Priority Tasks',
      desc: 'View high-priority SEO tasks you need to fix.'
    },
    {
      imgName: 'keyword/chart.svg',
      title: 'Spy on Competitors',
      desc: 'See what your competitors rank for and find new keyword opportunities.'
    },
    {
      imgName: isAgency
        ? 'keyword/track-rankings-v2.svg'
        : 'keyword/rocket.svg',
      title: isAgency ? 'Track Rankings' : 'Blog Post Ideas',
      desc: isAgency
        ? 'Monitor where you rank for your keywords with clear, simple reports.'
        : 'Generate ideas based on your competitors.'
    },
    {
      imgName: 'siteaudit/vector.svg',
      title: 'Audit Your Site',
      desc: 'Run a complete audit to detect SEO issues and quick fixes.'
    },
    {
      imgName: 'siteaudit/union.svg',
      title: 'Fix Broken Links',
      desc: 'Identify and resolve broken links that affect rankings.'
    },
    {
      imgName: 'keyword/chart.svg',
      title: 'Discover New Keywords',
      desc: 'Find long-tail keywords to boost organic traffic.'
    },
    {
      imgName: 'keyword/rocket.svg',
      title: 'Boost On-Page SEO',
      desc: 'Optimize titles, meta descriptions, and headers for higher visibility.'
    },
    {
      imgName: 'keyword/track.svg',
      title: 'Track Backlinks',
      desc: 'Monitor your backlink profile and lost links over time.'
    },
    {
      imgName: 'siteaudit/vector.svg',
      title: 'Improve Page Speed',
      desc: 'Analyze and speed up your site for better performance and SEO.'
    },
    {
      imgName: 'siteaudit/union.svg',
      title: 'Mobile SEO Check',
      desc: 'Ensure your website is mobile-friendly and ranks well on mobile searches.'
    },
    {
      imgName: 'keyword/chart.svg',
      title: 'Content Gap Analysis',
      desc: 'See where competitors rank and create content to close the gap.'
    },
    {
      imgName: 'keyword/rocket.svg',
      title: 'Generate SEO Reports',
      desc: 'Create easy-to-read SEO reports for clients or stakeholders.'
    },
    {
      imgName: 'keyword/track.svg',
      title: 'Track Competitor Backlinks',
      desc: 'See who is linking to your competitors and replicate their strategy.'
    },
    {
      imgName: 'siteaudit/vector.svg',
      title: 'Site Health Score',
      desc: 'Get a clear score for your website’s overall SEO health.'
    },
    {
      imgName: 'siteaudit/union.svg',
      title: 'Monitor Keyword Trends',
      desc: 'Stay ahead by tracking keyword popularity changes over time.'
    },
    {
      imgName: 'keyword/chart.svg',
      title: 'Analyze Top Pages',
      desc: 'Find your best-performing pages and optimize them further.'
    },
    {
      imgName: 'keyword/rocket.svg',
      title: 'Content Optimization',
      desc: 'Get suggestions to improve readability and keyword usage.'
    },
    {
      imgName: 'keyword/track.svg',
      title: 'Automated Alerts',
      desc: 'Receive alerts for ranking drops, new backlinks, or site issues.'
    },
    {
      imgName: 'keyword/chart.svg',
      title: 'Track Competitor Backlinks',
      desc: 'See who is linking to your competitors and replicate their strategy.'
    }
  ];

  //  Clean up: remove any `false` entries from the array
  return steps?.filter(Boolean);
};

export const dashboardTimelineOptions = [
  { value: 'last_7_days', label: 'Past 7 Days' },
  { value: 'last_28_days', label: 'Last 28 Days' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'last_12_months', label: 'Last 12 Months' },
  { value: 'since_seoSpace', label: 'Since using SEOSpace' },
  // { value: 'custom_date', label: 'Custom Date Range' }
];
export const AiVisibilityTexts = {
  yourMainCompetitors: 'Your Main Competitors',
  tooltipText: 'Websites competing with you for search visibility and traffic.',
  boostYourVisibility: 'Boost Your Visibility',
  startYourAiVisibility: 'Start Your AI Visibility',
  viewOurAiVisibilityGuide: 'View Our AI Visibility Guide'
};

export const AiVisibilityCardIcon = '/static/images/icons/ai_visibility.svg';

export const priceOrbitText = {
  title: 'Start Free, Upgrade Anytime. All plans include every feature.',
  modalTitle: 'The SEO work you never get to, done every week.',
  modalDesc: `Orbit puts five AI agents on your Squarespace site. They watch it, catch what is slipping, and write the fix. You review a finished queue of work instead of hunting for it.`
}
